<div class="history-filter-section">
  <abc-text-box
    #searchBox
    mode="search"
    (onValueChanged)="globalSearch($event)"
    placeholder="Search..."
    [disabled]="isLoading"
    valueChangeEvent="input"
  ></abc-text-box>

  <div class="filter-section-item">
    <dx-date-range-box
      #dateRangeBox
      class="date-range-box"
      [startDate]="startDate"
      [endDate]="endDate"
      (onValueChanged)="currentValueChanged($event)"
      [disabled]="isLoading"
    ></dx-date-range-box>
    <abc-button
      class="reload-button"
      icon="refresh"
      [hint]="translator('Audit-refresh')"
      (click)="resetFilters()"
      [disabled]="isLoading"
    ></abc-button>
  </div>
</div>
<abc-grid
  #historyOfChangesGrid
  id="historyOfChangesGrid"
  class="grid-group-by-Style abc-grid-custom-style grid-adaptive-mode"
  [height]="'85%'"
  [width]="'100%'"
  [rowAlternationEnabled]="false"
  [showRowLines]="true"
  [columns]="columnsHeader"
  [setupDefaultLayoutOnInitialization]="true"
  [dataSource]="filtredHistoryOfChanges"
  [columnHidingEnabled]="true"
  [wordWrapEnabled]="true"
  [columnAutoWidth]="false"
>
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <abc-load-panel></abc-load-panel>
</abc-grid>
